export default __webpack_public_path__ + "static/media/4.75aae60e.png";